'use strict';

var React = require('react');

var SvgChatMajor = function SvgChatMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 0c-5.514 0-10 4.486-10 10 0 1.728.45 3.42 1.304 4.924l-1.203 3.041c-.458 1.209.726 2.393 1.935 1.934l3.04-1.204a9.944 9.944 0 0 0 4.924 1.305c5.514 0 10-4.486 10-10s-4.486-10-10-10zm-4.707 9.293a.997.997 0 0 1 1.414 0 .997.997 0 0 1 0 1.414.997.997 0 0 1-1.414 0 .997.997 0 0 1 0-1.414zm4 0a.997.997 0 0 1 1.414 0 .997.997 0 0 1 0 1.414 1.003 1.003 0 0 1-1.414 0 1.003 1.003 0 0 1 0-1.414zm4.707-.293a.997.997 0 0 0-1 1 .997.997 0 0 0 1 1 .997.997 0 0 0 1-1 .997.997 0 0 0-1-1z"
  }));
};

exports.SvgChatMajor = SvgChatMajor;
